import React from "react";
import { Polar } from 'react-chartjs-2';
import '../App.css';
import '../Tooltip.css';
import UpTriangle from '../up_triangle.svg';
import DownTriangle from '../down_triangle.png';
import FlatRectangle from '../flat_rectangle.png';
import CallToAction from '../call_to_action.svg';

function Chart({ data, dataHash, prevYrDataHash }) {

  //variables

  const options = {
    legend: {
      display: false
    },
    maintainAspectRation: false,
    scale: {
      ticks: {
        min: 0,
        max: 100
      }
    }
  }

  const pillarDescriptions = {
    "Environment": " The environmental pillar measures a company's impact on living and non-living natural systems, including the air, land and water, as well as complete ecosystems. It reflects how well a company uses best management practices to avoid environmental risks and capitalize on environmental opportunities in order to generate long term shareholder value.",
    "Citizenship": " The citizenship pillar measures a company's capacity to generate trust and loyalty with its customers and society, through its use of best management practices. It is a reflection of the company's reputation and the health of its license to operate, which are key factors in determining its ability to generate long term shareholder value.",
    "Governance": "The corporate governance pillar measures a company's systems and processes, which ensure that its board members and executives act in the best interests of its long term shareholders. It reflects a company's capacity, through its use of best management practices, to direct and control its rights and responsibilities through the creation of incentives, as well as checks and balances in order to generate long term shareholder value."
  }

  const subpillarDescriptions = {
    "Resource Use Score": "Resource Use category score reflects a company's performance and capacity to reduce the use of materials, energy or water, and to find more ecoefficent solutions by improving supply chain management.",
    "Emissions Score": "Emissions category score measures a company's commitment and effectiveness towards reducing environmental emission in the production and operational processes.",
    "Innovation Score": "Environmental Innovation category score reflects a company's capacity to reduce the environmental costs and burdens for its customers, and thereby creating new market opportunities through new environmental technologies processes or eco-designed products.",
    "CSR Strategy Score": "CSR Strategy category score reflects a company's practices to communicate that it integrates the economic (financial), social and environmental dimensions into day-today decision-making processes.",
    "Community Score": "Community category score measures the company's commitment towards being a good citizen, protecting public health and respecting business ethics.",
    "Human Rights Score": "Human Rights category score measures a company's effectiveness towards respecting the fundamental human rights conventions.",
    "Product Responsibility Score": "Product Responsibility category score reflects a company's capacity to produce quality goods and services integrating the customer's health and safety, integrity and data privacy.",
    "ESG Controversies Score": "ESG Controversies category score measures a company's exposure to environmental, social and governance controversies and negative events reflected in global media.",
    "Workforce Score": "Workforce category score measures a company's effectiveness towards job satisfaction, healthy and safe workplace, maintaining diversity and equal opportunities, and development opportunities for its workforce.",
    "Management Score": "Management category score measures a company's commitment and effectiveness towards following best practice corporate governance principles.",
    "Shareholders Score": "Shareholders category score measures a company's effectiveness towards equal treatment of shareholders and the use of anti-takeover devices."
  }

  //helper functions
  const renderYoYTriangle = ( subpillar ) => { 
    if ( dataHash[subpillar] - prevYrDataHash[subpillar] > 0 ) {
      return <img src={UpTriangle} alt="green upward arrow" width={10} height={10} />
    } else if ( dataHash[subpillar] - prevYrDataHash[subpillar] === 0) {
      return <img src={FlatRectangle} alt="gray flat rectangle" width={10} />
    } else {
      return <img src={DownTriangle} alt="red downward arrow" width={10} height={10} />
    }
  }

  const renderYOYDescription = ( subpillar ) => {
    if ( dataHash[subpillar] - prevYrDataHash[subpillar] === 0 ){
      return( "No changes in score with previous fiscal year.")
    } else if ( dataHash[subpillar] - prevYrDataHash[subpillar] > 0 ) {
      return(`Score increased from ${prevYrDataHash[subpillar]} to ${dataHash[subpillar]}.`)
    } else if ( dataHash[subpillar] - prevYrDataHash[subpillar] < 0 ) {
      return(`Score decreased from ${prevYrDataHash[subpillar]} to ${dataHash[subpillar]}.`)
    }
  }

    return (
      <div className="Chart">
        <div className="Row">
          <div className="QuadrantStats">
            <div className="Quadrant">
              <p className="Pillar" id="EnvironmentPillar">Environment 
                <span id="EnvironmentTTText">{pillarDescriptions['Environment']}</span>
                <span>{Math.round(dataHash['Environment Pillar Score'])}</span>
                <img className="PillarCTA" src={CallToAction} alt="gray question mark" />
              </p>
                <div className="Row">
                  <p className="SubPillarLabel" id="ResourceUseToolTip">Resource Use <span id="ResourceUseToolTipText">{subpillarDescriptions['Resource Use Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Resource Use Score'])}</p>
                  <p className="SubPillarScore" id="ResourceUseTriTT">{renderYoYTriangle('Resource Use Score')} <span id="ResourceUseTriTTText">{renderYOYDescription('Resource Use Score')}</span></p>
                </div>
                <div className="Row">
                  <p className="SubPillarLabel" id="EmissionsToolTip">Emissions <span id="EmissionsToolTipText">{subpillarDescriptions['Emissions Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Emissions Score'])}</p>
                  <p className="SubPillarScore" id="EmissionsTriTT">{renderYoYTriangle('Emissions Score')} <span id="EmissionsTriTTText">{renderYOYDescription('Emissions Score')}</span></p>
                </div>
                <div className="Row">
                  <p className="SubPillarLabel" id="InnovationToolTip">Environmental Innovation <span id="InnovationToolTipText">{subpillarDescriptions['Innovation Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Innovation Score'])}</p>
                  <p className="SubPillarScore" id="InnovationTriTT">{renderYoYTriangle('Innovation Score')} <span id="InnovationTriTTText">{renderYOYDescription('Innovation Score')}</span></p>

                </div>
            </div>
            <div className="Quadrant">
              <p className="Pillar" id="CitizenshipPillar">Citizenship 
                <span id="CitizenshipTTText">{pillarDescriptions['Citizenship']}</span>
                <span>{Math.round(dataHash['Social Pillar Score'])}</span>
                <img className="PillarCTA" src={CallToAction} alt="gray question mark" />
              </p>
                <div className="Row">
                  <p className="SubPillarLabel" id="CSRStrategyToolTip">CSR Strategy <span id="CSRStrategyToolTipText">{subpillarDescriptions['CSR Strategy Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['CSR Strategy Score'])}</p>
                  <p className="SubPillarScore" id="CSRStratTriTT">{renderYoYTriangle('CSR Strategy Score')} <span id="CSRStratTriTTText">{renderYOYDescription('CSR Strategy Score')}</span></p>
                </div>
                <div className="Row">
                  <p className="SubPillarLabel"  id="CommunityToolTip">Community <span id="CommunityToolTipText">{subpillarDescriptions['Community Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Community Score'])}</p>
                  <p className="SubPillarScore" id="CommunityTriTT">{renderYoYTriangle('Community Score')} <span id="CommunityTriTTText">{renderYOYDescription('Community Score')}</span></p>
                </div>
                <div className="Row">
                  <p className="SubPillarLabel" id="HRToolTip">Human Rights <span id="HRToolTipText">{subpillarDescriptions['Human Rights Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Human Rights Score'])}</p>
                  <p className="SubPillarScore" id="HRTriTT">{renderYoYTriangle('Human Rights Score')} <span id="HRTriTTText">{renderYOYDescription('Human Rights Score')}</span></p>
                </div>
                <div className="Row">
                  <p className="SubPillarLabel" id="ProductResponsibilityToolTip">Product Responsibility <span id="ProductResponsibilityToolTipText">{subpillarDescriptions['Product Responsibility Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Product Responsibility Score'])}</p>
                  <p className="SubPillarScore" id="PRTriTT">{renderYoYTriangle('Product Responsibility Score')} <span id="PRTriTTText">{renderYOYDescription('Product Responsibility Score')}</span></p>
                </div>
            </div>
            <div className="Quadrant">
              <p className="Pillar" id="GovernancePillar">Governance 
                <span id="GovernanceTTText">{pillarDescriptions['Governance']}</span>
                <span>{Math.round(dataHash['Governance Pillar Score'])}</span>
                <img className="PillarCTA" src={CallToAction} alt="gray question mark" />
              </p>
                <div className="Row">
                  <p className="SubPillarLabel" id="ControversiesToolTip">ESG Controversies <span id="ControversiesToolTipText">{subpillarDescriptions['ESG Controversies Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['ESG Controversies Score'])}</p>
                  <p className="SubPillarScore" id="ControversiesTriTT">{renderYoYTriangle('ESG Controversies Score')} <span id="ControversiesTriTTText">{renderYOYDescription('ESG Controversies Score')}</span></p>
                </div>
                <div className="Row">
                  <p className="SubPillarLabel" id="WorkforceToolTip">Workforce <span id="WorkforceToolTipText">{subpillarDescriptions['Workforce Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Workforce Score'])}</p>
                  <p className="SubPillarScore" id="WorkforceTriTT">{renderYoYTriangle('Workforce Score')} <span id="WorkforceTriTTText">{renderYOYDescription('Workforce Score')}</span></p>
                </div>
                <div className="Row">
                  <p className="SubPillarLabel" id="ManagementToolTip">Management <span id="ManagementToolTipText">{subpillarDescriptions['Management Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Management Score'])}</p>
                  <p className="SubPillarScore" id="ManagementTriTT">{renderYoYTriangle('Management Score')} <span id="ManagementTriTTText">{renderYOYDescription('Management Score')}</span></p>
                </div>
                <div className="Row">
                  <p className="SubPillarLabel" id="ShareholdersToolTip">Shareholders <span id="ShareholdersToolTipText">{subpillarDescriptions['Shareholders Score']}</span></p>
                  <p className="SubPillarScore">{Math.round(dataHash['Shareholders Score'])}</p>
                  <p className="SubPillarScore" id="ShareholdersTriTT">{renderYoYTriangle('Shareholders Score')} <span id="ShareholdersTriTTText">{renderYOYDescription('Shareholders Score')}</span></p>
                </div>
            </div>
          </div>
          <div className="PolarArea">
            <Polar data={data} options={options} />
          </div>
        </div>
      </div>
    )
  }

export default Chart